import { defineExperiment } from '@cian/experiments/ab';

import { SHORT_FORM_WEB } from 'shared/common/constants/abExperiments';

/* A — контроль: маркетплейсный флоу с редиректом на ОШК.
   B — короткая анкета: онбординг /short-form/, а при наличии заявки сначала модалка */
export const ShortFormWebExperiment = defineExperiment(SHORT_FORM_WEB, {
  groups: ['A', 'B'] as const,
  default: 'A',
});
